<template>
  <main id="profile-main">
<!--    <account-list v-if="shouldSelectAccount" :action-str-select-chained="actionSelectChained" :accountType="allAccounts"/>-->
    <account-list
        v-if="shouldSelectAccount"
        :action-str-select-chained="actionSelectChained"
        :accountType="isHandler && !isInternal ? shippers : allAccounts"
        :handling="isHandler"
        @account-selected="handleAccountSelected"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('customerService.profile.title') }}
        </el-col>
      </el-row>
      <el-row v-if="shouldShowOptIn">
        <el-col :span="20" class="notification-info-container">
          <i class="el-icon-info"></i>&nbsp;
          <AgreementDialog :accountId="customer.id" :currentPhone="customer.phone" :is-link="true" :option-text="$t('common.optInToEtaSms')"/>
        </el-col>
      </el-row>
      <el-row :gutter="5" class="title-header-row">
        <el-col :span="18">
          <div class="header-info">
              <span class="title-header title-list">{{ customer.name }}</span>
              <span class="subtitle-header title-list">{{ customer.number }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <el-select v-if="hierarchyData" v-model="childSelected" size="medium" class="select-tree-view" :placeholder="$t('account.tabs.hierarchy')" @change="childAccountSelected">
            <el-option v-for="item in hierarchyData" :key="item.id" :label="item.label" :value="item.id">
              <span :class="item.current && 'current-account'">{{ item.label }}</span>
              <span v-if="!item.active"
                    class="status status-inactive"
                    :title="'Inactive Account'"
                >
                  {{ '✕' }}
                </span>
                <span v-if="item.current"
                 class="current-account"
                >
                  {{ ' - Current' }}
                </span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <CustomerMasterRecord :isProfileView="true"  :account-data="selectedAccountFromList"/>
    </div>
  </main>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import constants from '@/utils/constants';
import AccountList from '@/components/AccountList';
import { ACCOUNT_HIERARCHY, ACCOUNT_SEARCH } from '@/store/actions';
import CustomerMasterRecord from '@/views/customerCenter/customerMasterRecord/index';
import AgreementDialog from './agreement';

export default {
  name: 'CustomerServiceProfile',
  components: {
    CustomerMasterRecord,
    AccountList,
    AgreementDialog
  },
  data() {
    return {
      childSelected: null,
      actionSelectChained: ['customerMasterRecord/searchProfile'],
      allAccounts: constants.ACCOUNTS.TYPE[0].value,
      shippers: constants.ACCOUNTS.TYPE[1].value,
      selectedAccountFromList: null
    };
  },
  watch: {
    // Vigilamos 'customer' por si la carga inicial de datos tarda un poco
    customer: {
      immediate: true,
      handler(newVal) {
        if (!this.shouldSelectAccount && newVal && newVal.id) {
          this.selectedAccountFromList = newVal;
        }
      }
    }
  },
  /* watch: {
    childSelected(newVal) {
      // Aquí puedes manejar el cambio de selección, por ejemplo, cargar datos relacionados con el nuevo valor
      console.log('Selected child ID:', newVal); // Debug: Verificar el nuevo valor seleccionado
    }
  }, */
  computed: {
    ...mapGetters(['customerMasterRecord']),
    customer() {
      return this.customerMasterRecord.list[0] || { name: '', number: '' };
    },
    isInternal() {
      const roles = this.$store.state.user.roles || [];
      return roles.some(role => role.toLowerCase() === 'admin' || role.toLowerCase() === 'internal');
    },
    isHandler() {
      const roles = this.$store.state.user.roles || [];
      return !!this.customer.handler || roles.some(role => role.toLowerCase() === 'shipper');
    },
    hierarchyData() {
      const currentAccount = this.customerMasterRecord.list[0];
      if (!currentAccount) {
        return [];
      }
      const parentData = this.customerMasterRecord.parentTreeData || [];
      const treeData = parentData.length > 0 ? parentData[0].children : [];
      const mappedTreeData = treeData.map(item => ({
        id: item.id,
        label: item.label,
        active: item.active,
      }));
      const mappedCurrentAccount = currentAccount ? {
        id: currentAccount.id,
        label: `${currentAccount.name} - (${currentAccount.number})`,
        active: currentAccount.active,
        current: true
      } : null;
      return [mappedCurrentAccount, ...mappedTreeData];
    },
    shouldShowOptIn() {
      return this.customer && this.customer.id && (this.customer.termsAndConditionsAccepted == null && !this.customer.smsOn);
    },
    shouldSelectAccount() {
      return this.isInternal || this.isHandler;
    }
  },
  methods: {
    ...mapActions({
      hierarchy: ACCOUNT_HIERARCHY,
      search: ACCOUNT_SEARCH,
    }),
    handleAccountSelected(account) {
      this.selectedAccountFromList = account;
      this.selectedAccountFromList.type = constants.ACCOUNTS.TYPE[account.accountTypeId].value;
    },
    checkPreselectedAccount() {
      // Si el selector NO se muestra, usamos la cuenta cargada por defecto
      if (!this.shouldSelectAccount && this.customer && this.customer.id) {
        this.selectedAccountFromList = this.customer;
      }
    },
    childAccountSelected() {
      if (this.childSelected) {
        this.customerMasterRecord.searchForm.number = null;
        this.customerMasterRecord.searchForm.id = this.childSelected;
        this.customerMasterRecord.activeName = 'prof';
        this.search().then(() => {
          this.$store.dispatch('customerMasterRecord/setTabsActiveType', this.customerMasterRecord.list[0].type || '');
        });
      }
    }
  },
  mounted() {
    this.checkPreselectedAccount();
    if (this.customerMasterRecord.list.length > 0) {
      this.hierarchy(this.customerMasterRecord.list[0].id);
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../../styles/variables.scss";

.title-header-row {
  margin: 20px;
}
.header-info {
  display: flex;
  flex-direction: row;
}
.title-header {
  margin-left: 20px;
  font-size: 2rem;
  font-weight: 800;
  width: fit-content;
}
.subtitle-header {
  color: #606266;
  margin-left: 1em;
  font-size: 1.2rem;
  font-weight: 500;
  width: fit-content;
}
.notification-info-container {
  border-left: $blueLink 4px solid;
  height: 2rem;
  padding-left: 0.5rem;
  align-content: center;
  color: $blueLink;
}
.opt-in-button {
  background-color: transparent;
  color: $blueLink;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
}
.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  font-size: 10px;
  line-height: 1;
  border-radius: 50%;
  color: white;
  font-weight: 700;
  margin-left: 0.5em;
}
.status-inactive {
  background: #e74c3c; /* rojo */
}
.current-account {
  font-weight: 700;
  color: $darkBlueArmellini;
}
</style>
